angular.module('wbControllers').controller('ToolsController',
  ['$scope', '$location', ($scope, $location) => $scope.$on('$locationChangeSuccess', () => { $scope.toolSelected = $location.search().tool; })]);
